var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6424A9F66Da9F04017Cba53DPassionIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_17854)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.7386,
    cy: 13.7677,
    r: 13.3048,
    fill: "#FF7020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9305 54.4627C27.9305 54.4627 1.47217 39.646 1.47217 21.6543C1.47217 18.4738 2.57414 15.3914 4.5906 12.9317C6.60706 10.472 9.41344 8.78696 12.5323 8.1632C15.6511 7.53943 18.8897 8.0155 21.6971 9.51042C24.5045 11.0053 26.7072 13.4268 27.9305 16.3627C29.1538 13.4268 31.3565 11.0053 34.1639 9.51042C36.9713 8.0155 40.2099 7.53943 43.3287 8.1632C46.4475 8.78696 49.2539 10.472 51.2704 12.9317C53.2868 15.3914 54.3888 18.4738 54.3888 21.6543C54.3888 39.646 27.9305 54.4627 27.9305 54.4627Z",
    stroke: "white",
    strokeWidth: 1.42551,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_17854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6424A9F66Da9F04017Cba53DPassionIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6424a9f66da9f04017cba53d_passion-icon-darkstudio-x-webflow-template.bb4f2c1745325804918e8ce2672487da.svg";
export { ForwardRef as ReactComponent };